import { submitFeedback, fetchFeedbacks, fetchFeedbackById, updateFeedbackStatus, deleteFeedback } from '../api';

// Action Types
export const FEEDBACK_SUBMIT_REQUEST = 'FEEDBACK_SUBMIT_REQUEST';
export const FEEDBACK_SUBMIT_SUCCESS = 'FEEDBACK_SUBMIT_SUCCESS';
export const FEEDBACK_SUBMIT_FAILURE = 'FEEDBACK_SUBMIT_FAILURE';

export const FEEDBACKS_FETCH_REQUEST = 'FEEDBACKS_FETCH_REQUEST';
export const FEEDBACKS_FETCH_SUCCESS = 'FEEDBACKS_FETCH_SUCCESS';
export const FEEDBACKS_FETCH_FAILURE = 'FEEDBACKS_FETCH_FAILURE';

export const FEEDBACK_FETCH_REQUEST = 'FEEDBACK_FETCH_REQUEST';
export const FEEDBACK_FETCH_SUCCESS = 'FEEDBACK_FETCH_SUCCESS';
export const FEEDBACK_FETCH_FAILURE = 'FEEDBACK_FETCH_FAILURE';

export const FEEDBACK_STATUS_UPDATE_REQUEST = 'FEEDBACK_STATUS_UPDATE_REQUEST';
export const FEEDBACK_STATUS_UPDATE_SUCCESS = 'FEEDBACK_STATUS_UPDATE_SUCCESS';
export const FEEDBACK_STATUS_UPDATE_FAILURE = 'FEEDBACK_STATUS_UPDATE_FAILURE';

export const FEEDBACK_DELETE_REQUEST = 'FEEDBACK_DELETE_REQUEST';
export const FEEDBACK_DELETE_SUCCESS = 'FEEDBACK_DELETE_SUCCESS';
export const FEEDBACK_DELETE_FAILURE = 'FEEDBACK_DELETE_FAILURE';

// Action Creators
export const submitFeedbackForm = (feedbackData) => async (dispatch) => {
    dispatch({ type: FEEDBACK_SUBMIT_REQUEST });
    
    try {
        const response = await submitFeedback(feedbackData);
        dispatch({ 
            type: FEEDBACK_SUBMIT_SUCCESS, 
            payload: response.data 
        });
        return response.data;
    } catch (error) {
        dispatch({ 
            type: FEEDBACK_SUBMIT_FAILURE, 
            payload: error.response?.data?.message || 'Failed to submit feedback form' 
        });
        throw error;
    }
};

export const fetchAllFeedbacks = () => async (dispatch) => {
    dispatch({ type: FEEDBACKS_FETCH_REQUEST });
    
    try {
        const response = await fetchFeedbacks();
        dispatch({ 
            type: FEEDBACKS_FETCH_SUCCESS, 
            payload: response.data 
        });
        return response.data;
    } catch (error) {
        dispatch({ 
            type: FEEDBACKS_FETCH_FAILURE, 
            payload: error.response?.data?.message || 'Failed to fetch feedbacks' 
        });
        throw error;
    }
};

export const fetchFeedback = (id) => async (dispatch) => {
    dispatch({ type: FEEDBACK_FETCH_REQUEST });
    
    try {
        const response = await fetchFeedbackById(id);
        dispatch({ 
            type: FEEDBACK_FETCH_SUCCESS, 
            payload: response.data 
        });
        return response.data;
    } catch (error) {
        dispatch({ 
            type: FEEDBACK_FETCH_FAILURE, 
            payload: error.response?.data?.message || 'Failed to fetch feedback' 
        });
        throw error;
    }
};

export const updateFeedback = (id, status) => async (dispatch) => {
    dispatch({ type: FEEDBACK_STATUS_UPDATE_REQUEST });
    
    try {
        const response = await updateFeedbackStatus(id, status);
        dispatch({ 
            type: FEEDBACK_STATUS_UPDATE_SUCCESS, 
            payload: response.data 
        });
        return response.data;
    } catch (error) {
        dispatch({ 
            type: FEEDBACK_STATUS_UPDATE_FAILURE, 
            payload: error.response?.data?.message || 'Failed to update feedback status' 
        });
        throw error;
    }
};

export const deleteFeedbackSubmission = (id) => async (dispatch) => {
    dispatch({ type: FEEDBACK_DELETE_REQUEST });
    
    try {
        await deleteFeedback(id);
        dispatch({ 
            type: FEEDBACK_DELETE_SUCCESS, 
            payload: id 
        });
    } catch (error) {
        dispatch({ 
            type: FEEDBACK_DELETE_FAILURE, 
            payload: error.response?.data?.message || 'Failed to delete feedback' 
        });
        throw error;
    }
}; 